export function scrollIntoView (element) {
  this.$nextTick(() => {
    const el = document.getElementById(element)

    if (el !== null) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  })
}

export function cardActiveStyle (active = Boolean) {
  if (active) {
    return {
      color: 'white !important'
    }
  }
}

export function wizardIcon (item) {
  const resources = {
    wordpress: '/static/img/wizard/applications/wordpress.png',
    extendify: '/static/img/wizard/applications/wp-ai2.png',
    wpwoocommerce: '/static/img/wizard/applications/woocommerce.png',
    woocommerce: '/static/img/wizard/applications/woocommerce.png',
    sitepad: '/static/img/wizard/applications/sitepad.png',
    elementor: '/static/img/wizard/plugins/elementor.png',
    'wpforms-lite': '/static/img/wizard/plugins/wp-forms.png',
    loginizer: '/static/img/wizard/plugins/loginizer.png',
    'wp-central': '/static/img/wizard/plugins/wpcentral.png',
    'optinmonster': '/static/img/wizard/plugins/optinmonster.png',
    'google-analytics-for-wordpress': '/static/img/wizard/plugins/google-analytics-for-wordpress.png',
    'New Website': 'gg-wiz-icon-plus-circle',
    'Migration': 'gg-wiz-icon-arrow-circle-right',
    'Starter Site': 'mdi-file-code',
    'Skip This': 'mdi-debug-step-over',
  }

  if (resources[item.key] !== undefined) {
    return resources[item.key]
  } else {
    return 'gg-wiz-icon-gears'
  }
}

export function themeImage (key) {
  const images = {
    'Option A': '/static/img/wizard/themes/starter/option_a.jpg',
    'Option B': '/static/img/wizard/themes/starter/option_b.png'
  }
  return images[key] || '/static/img/wizard/themes/starter/default.png'
}

export const path = [
  {
    id: 0,
    name: 'Start New Website',
    subtitle: 'Create an entirely new website',
    key: 'New Website',
    img: false
  },
  {
    id: 1,
    name: 'Migrate Website',
    subtitle: 'Move over an existing website',
    key: 'Migration',
    img: false
  },
  {
    id: 2,
    name: 'Starter Site',
    subtitle: 'Let\'s build your website together',
    key: 'Starter Site',
    img: false
  },
  {
    id: 3,
    name: 'Skip This',
    subtitle: 'I will take care of the setup myself',
    key: 'Skip This',
    img: false
  },
]

export const themes = [
  {
    id: 0,
    name: 'Default Theme',
    key: 'default'
  },
  {
    id: 1,
    name: 'Theme 1',
    key: 'theme1'
  },
  {
    id: 2,
    name: 'Theme 2',
    key: 'theme2'
  },
  {
    id: 3,
    name: 'Theme 3',
    key: 'theme3'
  },
  {
    id: 4,
    name: 'Theme 4',
    key: 'theme4'
  }
]

export const plugins = [
  {
    id: 0,
    name: 'WooCommerce',
    key: 'woocommerce'
  },
  {
    id: 1,
    name: 'Elementor Page Builder',
    key: 'elementor',
  },
  {
    id: 2,
    name: 'WPForms Lite',
    key: 'wpforms-lite'
  },
  {
    id: 3,
    name: 'Limit Login Attempts (Loginzer)',
    key: 'loginizer'
  },
  {
    id: 4,
    name: 'wpCentral - Manage Multiple WordPress',
    key: 'wp-central'
  }
]

export const caching = [
  {
    id: 0,
    name: 'Enable LiteSpeed Cache',
    key: true
  }
]

export const applications_alt = [
  {
    id: 0,
    name: 'General Wesite',
  },
  {
    id: 1,
    name: 'Blog',
  },
  {
    id: 2,
    name: 'Online Store',
  },
]

export const dummy_data = {
  'result': 'success',
  'serviceID': '1',
  'serviceDomain': 'ronkh.com',
  'applications': [
    {
      'key': 'wordpress',
      'name': 'WordPress',
      'flow': 'wordpress',
      'defaults': {
        'theme': 'default',
        'plugins': [],
        'caching': true
      }
    },
    {
      'key': 'wpwoocommerce',
      'name': 'WordPress + WooCommerce',
      'flow': 'wordpress',
      'defaults': {
        'theme': 'default',
        'plugins': [
          'woocommerce'
        ],
        'caching': true
      }
    },
    {
      'key': 'sitepad',
      'name': 'SitePad',
      'flow': 'sitebuilder',
      'defaults': false
    },
  ],
  'wordpressThemes': [
    {
      'key': 'default',
      'name': 'Default Theme'
    },
    {
      'key': 'theme1',
      'name': 'Theme 1'
    },
    {
      'key': 'theme2',
      'name': 'Theme 2'
    },
    {
      'key': 'theme3',
      'name': 'Theme 3'
    },
    {
      'key': 'theme4',
      'name': 'Theme 4'
    },
    {
      'key': 'divi',
      'name': 'Divi'
    }
  ],
  'wordpressPlugins': [
    {
      'key': 'woocommerce',
      'name': 'WooCommerce'
    },
    {
      'key': 'elementor',
      'name': 'Elementor'
    },
    {
      'key': 'wpforms-lite',
      'name': 'WPForms Lite'
    },
    {
      'key': 'loginizer',
      'name': 'Limit Login Attempts (Loginizer)'
    },
    {
      'key': 'wp-central',
      'name': 'wpCentral - Manage Multiple WordPress'
    },
    {
      'key': 'hellodolly',
      'name': 'Hello Dolly'
    }
  ],
  'token': '',
  'apiVersion': 2
}
